import React, { useEffect, useState } from "react";
import withLoader from "../layouts/WithLoader";
import SellingService from "../../services/SellingService";
import ErrorAlert from "../layouts/ErrorAlert";
import ListTotalPayementBill from "./payement/ListTotalPayementBill";
import SocieteFactureBox from "../../models/SocieteFactureBox";
import ExtratFacture from "../../models/ExtratFacture";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import UploadAndDownloadService from "../../services/uploadAndDownloadFile";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import UtilsFormule from "../../utils/UtilsFormule";
import ListAvancePayementBC from "./payement/ListAvancePayementBC";
import MethodePayementBillTotal from "./payement/MethodePayementBillTotal";
import MethodePayementBillAvance from "./payement/MethodePayementBillAvance";
import SimulateRetenuVente from "./SimulateRetenuVente";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import TierAccountService from "../../services/PayementSolde/TierAccountService";

const PayementBillVenteDetails = ({ startLoading, stopLoading }) => {
  const [factureInformation, setFactureInformation] = useState({});
  const [payementInformations, setPayementInformations] = useState({});
  const [totalPayementInformation, setTotalPayementInformation] = useState({});

  const [retenuExistance, setRetenuExistance] = useState(false);
  // const [retenuData, setRetenuData] = useState({});
  // const [societeCliente, setSocieteCliente] = useState("");
  // const [societePartner, setSocietePartner] = useState("");
  // const [bill, setBill] = useState("");
  // const [extratBill, setExtratBill] = useState([]);
  const [alert_message, setAlertMessage] = useState("");
  const [retenu, setRetenu] = useState("");
  const [ChoosePayement, setChoosePayement] = useState("");
  const [certificatRetenu, setCertificatRetenu] = useState(false);

  const [buttonClicked, setButtonClicked] = useState("");
  // const [payed, setPayed] = useState(false);
  // const [bonCommande, setBonCommande] = useState("");
  const [amountMax, setAmountMax] = useState("");
  const [companyInfo, setCompanyInfo] = useState({});
  const [clientInfo, setClientInfo] = useState({});
  const [userRole, setUserRole] = useState("");

  const [restToPay, setRestToPay] = useState(0);
  const [totalHT, setTotalHT] = useState(0);
  const [totalTT, setTotalTT] = useState(0);
  // const [montantRetenuBE, setMontantRetenuBE] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [percenteRetenu, setPercenteRetenu] = useState(0);
  const [amountRetenu, setAmountRetenu] = useState(0);
  const [typeWallet, setTypeWallet] = useState(false);
  const [wallet, setWallet] = useState();

  const [fileName, setFileName] = useState("");
  const [messageUpload, setMessageUpload] = useState("");
  const [onSimulate, setOnSimulate] = useState(false);
  const [simulateData, setSimulateData] = useState();

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
    startLoading();
    SellingService.getDocumentForPayementTask(
      localStorage.getItem("idBill"),
      "1"
    )
      .then((response) => {
        if (response.data["success"]) {
          // let generateRetenueSourceModel = {
          //   idUser: 4,
          //   refFacture: [response.data["success"].ref],
          // };
          localStorage.setItem("company", response.data["company"].title)
          localStorage.setItem("adresse", response.data["company"].adresse)
          localStorage.setItem("client", response.data["client"].title)


          let montantR = 0;
          if (response.data["success"]?.finalPriceTt != null) {
            montantR = response.data["success"]?.finalPriceTt;
          } else if (response.data["success"]?.priceTT != null) {
            montantR = response.data["success"].priceTT;
          }

          setRestToPay(montantR);
          setCompanyInfo(response.data["company"]);
          setClientInfo(response.data["client"]);

          setFactureInformation(response.data["success"]);

          if (factureInformation?.finalPriceHt) {
            setTotalHT(response.data["success"].finalPriceHT);
          } else {
            setTotalHT(response.data["success"].sellingPrice);
          }
          if (factureInformation?.finalPriceTT) {
            setTotalTT(response.data["success"].finalPriceTt);
          } else {
            setTotalTT(response.data["success"].priceTT);
          }
          console.log("clientInfo", response.data["client"].id)
          localStorage.setItem("idTierWallet", response.data["client"].id);
          TierAccountService.getWalletByTier(getCurrentUserId(), response.data["client"].id)
            .then((response) => {
              if (response.data.success) {

                setTypeWallet(true);
                setWallet(response.data.success);
              }
            })
            .catch((error) => {
              setAlertMessage("error " + error);
            })
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
    startLoading();
    SellingService.getFacturePayementInformation(
      localStorage.getItem("idBill"),
      "FACTURE"
    )
      .then((response) => {
        if (response.data["Payement"]) {

          setPayementInformations(response.data["Payement"]);
          if (response.data["Payement"]?.id != null) {
            setRestToPay(response.data["Payement"]?.restToPay);
          }
        } else if (response.data["payementInformationFacture"]) {
          setTotalPayementInformation(response.data["PayementTotal"]);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });

  }, []);

  const changePercentRetenu = (event) => {
    console.log("event", event.target.value);
    setPercenteRetenu(event.target.value);
  };

  const changeAmountRetenu = (event) => {
    console.log("event", event.target.value);
    setAmountRetenu(event.target.value);
  };

  const onFileChangeHandler = (event) => {
    if (event.target.files[0].size > 2097152) {
      toast.info("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileName(event.target.files[0].name);
      setSelectedFile(event.target.files[0]);
    }
  };
  const onShowFileInOtherWizndowHandler = (path) => {
    startLoading();

    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : il ya un probléme de connection");
      })
      .finally(() => {
        stopLoading();
      });
  };
  const saveRetenue = (e) => {
    if (selectedFile != null) {
      const uploadData = new FormData();
      uploadData.append("picture", selectedFile);
      startLoading();
      SellingService.uploadFile("/uploadFile/Payement", uploadData)
        .then((response) => {
          if (response.data["success"]) {
            let retenuModel = {
              idUser: getCurrentUserId(),
              idFacture: factureInformation.id,
              percentRetenu: percenteRetenu,
              amount: amountRetenu,
              urlFile: response.data["success"],
            };

            SellingService.saveRetenuSourceVenteWithFileV2(retenuModel)
              .then((response) => {
                if (response.data["path"]) {
                  onShowFileInOtherWizndowHandler(response.data["path"]);
                } else {
                  toast.error(
                    "Erreur  : il y'a un probléme au niveau de serveur"
                  );
                }
              })
              .catch((error) => {
                toast.error(
                  "Erreur  : " + error
                );
              });
            console.log(response, "data");
            setMessageUpload("Votre fichier a été enregistré avec succés");
          } else {
            toast.error("Erreur : il ya un probléme au niveau de serveur");
            setMessageUpload("il ya un probléme au niveau de serveur");
          }
        })
        .catch(() => {
          toast.error("Erreur : il ya un probléme de connection");
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  const finaliserBill = (e) => {
    SellingService.finaliserPayement(1, factureInformation?.id)
      .then((response) => {
        if (response.data.error) {
          toast.error("Error : il ya un probléme");
        } else {
          toast.success("Opération avec succès");
        }
      })
      .catch((error) => {
        toast.error("Error : il ya un probléme");
      });
  };
  const buttonFinaliserPayement = () => {
    if (!userRole.includes("COMMERCIAL")) {
      if (factureInformation?.payed === 1) {
        return null;
      } else {
        return (
          <button
            type="submit"
            onClick={(e) => {
              finaliserBill();
              // setButtonClicked("clicked");
            }}
            className="btn btn-dark float-right"
          >
            Finaliser le payement
          </button>
        );
      }
    }
  };
  const generateAndDownloadRetenu = (event) => {
    // retenuUrl, id
    console.log("generateAndDownloadRetenu", factureInformation?.retenuSource);
    if (
      factureInformation?.retenuSource !== "any" &&
      factureInformation?.retenuSource !== null &&
      factureInformation?.retenuSource !== null
    ) {
      onShowFileInOtherWizndowHandler(
        factureInformation.retenuSource.retenuUrl
      );
    } else {
      startLoading();

      SellingService.generateRetenuSourceV2(
        getCurrentUserId(),
        percenteRetenu,
        amountRetenu,
        factureInformation.id
      )
        .then((response) => {
          console.log("response ", response);
          if (response.data["path"]) {
            onShowFileInOtherWizndowHandler(response.data["path"]);
          } else {
            toast.error("Erreur : il y'a un probléme au niveau de serveur");
          }
        })
        .catch((error) => {
          toast.error("Erreur : " + error);
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  // const getAvancesPayementBC = () => {
  //   if (payementInformations?.id != null) {
  //     if (payementInformations?.bonDeCommande?.id != null) {
  //       return (
  //         <ListAvancePayementBC
  //           idBC={payementInformations?.bonDeCommande["id"]}
  //         />
  //       );
  //     } else {
  //       return <div className="col-12"></div>;
  //     }
  //   }
  // };
  const retenubtnPayement = () => {
    if (!userRole.includes("COMMERCIAL")) {
      if (factureInformation?.retenuSource === null) {
        return (
          <button
            type="submit"
            onClick={(e) => {
              setCertificatRetenu(true);
            }}
            className="btn btn-dark float-right"
          >
            Retenu
          </button>
        );
      }
    }
  };
  const buttonPayement = () => {
    if (!userRole.includes("COMMERCIAL")) {
      if (parseFloat(amountMax) === 0) {
        return <div class="col-md-12"></div>;
      } else if (
        factureInformation?.id != null &&
        parseInt(factureInformation?.sellingPrice) < parseInt(restToPay) &&
        parseInt(restToPay) !== 0
      ) {
        return (
          <button
            type="submit"
            onClick={(e) => {
              setButtonClicked("clicked");
            }}
            className="btn btn-dark float-right"
          >
            Continuer le payement
          </button>
        );
      } else if (
        (factureInformation?.id != null &&
          parseInt(restToPay) === parseInt(factureInformation?.sellingPrice)) ||
        factureInformation?.payed === 0
      ) {
        return (
          <button
            type="submit"
            onClick={(e) => {
              console.log("retenu", retenu);
              // if (retenuExistance) {
              //   if (
              //     window.confirm("Voulez vous obtenir une certificat de retenu?")
              //   ) {
              //     setCertificatRetenu(true)
              //   }
              // }
              setButtonClicked("clicked");
            }}
            className="btn btn-dark float-right"
          >
            Commencer le payement
          </button>
        );
      }
    }
    else {
      return <div className="col-12"></div>;
    }
  };
  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setChoosePayement(payement);

    console.log("methode Payement", ChoosePayement);
  };
  const DynamiquePayement = () => {
    if (buttonClicked === "clicked") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark ">
                <div className="card-header">
                  <h3 className="card-title">1-Première étape: </h3>
                  <br />
                </div>

                <div className="card-body">
                  <h5 className="card-title">
                    Choisir de payer la totalité du montant ou une avance
                  </h5>
                  <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">
                      <select
                        class="form-control"
                        onChange={(e) => handleChangePayement(e)}
                      >
                        <option key={0} value={0}>
                          Payer
                        </option>
                        <option key={1} value={"TOTAL"}>
                          La totalité du montant
                        </option>
                        <option key={2} value={"AVANCE"}>
                          Une avance
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {payementChooseUI()}
        </section>
      );
    }
  };

  const payementChooseUI = () => {
    if (ChoosePayement === "TOTAL") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">2-Deuxième étape:</h3>
                </div>
                <MethodePayementBillTotal
                  typeWallet={typeWallet}
                  restToPay={restToPay}
                />
              </div>
            </div>
          </div>
        </section>
      );
    } else if (ChoosePayement === "AVANCE") {
      return (
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">2-Deuxième étape: </h3>
              </div>
              <MethodePayementBillAvance
                typeWallet={typeWallet}
                restToPay={restToPay}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  const onSimulateRetenu = () => {
    let simulData = {
      idDocument: factureInformation?.id,
    };
    setSimulateData(simulData);
    setOnSimulate(true);
  };
  const certificatUIResult = () => {
    if (certificatRetenu) {
      if (factureInformation?.retenuSource === null) {
        return (
          <div class="col-12">
            <div className="card card-outline card-dark">
              <div className="card-body">
                <div className="form-group files color">
                  <div class="row">
                    <div className="col-md-12">
                      <div class="row">
                        <div className="col-md-6">
                          <label>Choisir le pourcentage de retenu: </label>
                          <input
                            type="number"
                            min="0"
                            step="0.1"
                            class="form-control"
                            name="amount"
                            onChange={(e) => changePercentRetenu(e)}
                          />
                        </div>
                        <div className="col-md-6">
                          <label>Choisir le montant de retenu: </label>
                          <input
                            type="number"
                            min="0"
                            step="0.1"
                            class="form-control"
                            name="amount"
                            // defaultValue={percenteRetenu}
                            onChange={(e) => changeAmountRetenu(e)}
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div className="form-group">
                        {" "}
                        <label for="exampleInputFile">Retenu </label>
                        <div class="input-group">
                          <div class="custom-file">
                            <input
                              accept="application/pdf, .jpg, .jpeg, .png"
                              type="file"
                              className="custom-file-input"
                              id="exampleInputFile"
                              onChange={onFileChangeHandler}
                            />
                            <label
                              class="custom-file-label"
                              for="exampleInputFile"
                            >
                              {fileName}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div class="col-md-9"></div>
                    <div class="col-md-1">
                      <button
                        className="btn btn-dark float-right"
                        onClick={saveRetenue}
                      >
                        <i class="fas fa-file-lines"></i> Enregistrer
                      </button>
                    </div>
                    <div className="col-md-1">
                      <button
                        className="btn btn-dark float-right"
                        onClick={generateAndDownloadRetenu}
                      >
                        <i class="fas fa-download"></i> Générer
                      </button>
                    </div>
                    <div className="col-md-1">
                      <button
                        className="btn btn-dark float-right"
                        data-toggle="modal"
                        data-target="#simuler-retenu"
                        onClick={onSimulateRetenu}
                      >
                        <i class="fas fa-eye"></i> Simuler
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
    if (
      factureInformation?.retenuSource !== null &&
      factureInformation?.retenuSource?.creationDate !== null
    ) {
      return (
        <div class="col-12">
          <div className="card card-outline card-dark">
            <div class="card-header">
              <h3 class="card-title">
                Retenu à la source généré le{" "}
                {UtilsFormule.formatDate(
                  factureInformation?.retenuSource?.creationDate
                )}
              </h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                  title="Collapse"
                >
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="form-group files color">
                <div class="row">
                  <div class="col-md-12">
                    <label>
                      Montant du retenu :
                      {factureInformation?.retenuSource?.retenuAmmount} TND{" "}
                    </label>
                  </div>
                  <div class="col-md-12">
                    <label>
                      Pourcentage de retenu:{" "}
                      {factureInformation?.retenuSource?.retenuPercent} %{" "}
                    </label>
                  </div>

                  <div className="col-md-12">
                    <button
                      className="btn btn-dark float-right"
                      onClick={(e) => generateAndDownloadRetenu(e)}
                    >
                      <i class="fas fa-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  const payedTag = (isPayed) => {
    if (isPayed === 0) {
      return (<span style={{ cursor: "pointer" }} className="badge bg-warning">
        Non Payée
      </span>)
    } else if (isPayed === 1) {
      return <span style={{ cursor: "pointer" }} className="badge bg-success">
        Payée
      </span>
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {alert_message === "error" ? (
        <>
          <section className="content">
            <br />
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <ErrorAlert message="Désolé aucune facture à afficher" />
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          <ToastContainer />
          <div class="container-fluid">
            {console.log(
              "payementInformations?.payementInformationFacture",
              restToPay
            )}
            <br />
            <section className="invoice p-3 mb-3">
              <div className="col-xs-12">
                <h2 className="page-header">
                  <i className="fas fa-globe-africa" />
                  {factureInformation?.title}
                  <small className="float-center">{payedTag(factureInformation?.payed)}</small>

                  <small className="float-right">
                    Date:{" "}
                    {UtilsFormule.formatDate(factureInformation?.createionDate)}
                  </small>
                  <small className="float-right"></small>
                </h2>
              </div>

              <div className="row invoice-info">
                <div className="col-sm-6 invoice-col">
                  Détails Facture
                  <address>
                    <strong>
                      {factureInformation?.ref}-{factureInformation?.title}
                    </strong>
                    <br />

                    {factureInformation?.note != null
                      ? factureInformation?.note
                      : "Vide"}
                    <br />
                  </address>
                </div>
                <SocieteFactureBox societe={companyInfo} role="Emetteur" />
                <SocieteFactureBox
                  societe={factureInformation?.client}
                  role="Client"
                />
              </div>
              <div className="row">
                <div class="col-6"></div>
                <div class="col-6">
                  <ExtratFacture extracts={factureInformation?.sales} />
                </div>
              </div>
              <div className="row">
                <div class="col-7"></div>
                <div class="col-4">
                  <div className="table-responsive ">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th style={{ width: "50%" }}>Total HT:</th>
                          <td>{totalHT} DNT</td>
                        </tr>

                        <tr>
                          <th>Timbre:</th>
                          <td>{factureInformation?.timbre}</td>
                        </tr>
                        <tr>
                          <th>Total TT:</th>
                          <td>{totalTT} DNT</td>
                        </tr>

                        <tr>
                          <th>Reste à payer:</th>
                          <td>{Math.round(restToPay * 1000) / 1000} TND</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-1"></div>
              </div>
              <div class="box-footer"></div>
              <br />
              <br />
            </section>

            {payementInformations?.id != null ? (
              <ListTotalPayementBill
                payementInformations={
                  payementInformations?.payementInformationFacture
                }
              />
            ) : totalPayementInformation?.idPayementTotal != null ? (
              <ListTotalPayementBill
                totalPayementInformation={totalPayementInformation}
              />
            ) : null}
            <div className="row float-right">
              <div class="col-12">{retenubtnPayement()}</div>
            </div>
            <br /> <br />
            <div className="row">{certificatUIResult()}</div>
            {buttonPayement()}
            <div className="row">{buttonFinaliserPayement()}</div>
            <br />
            <br />
            {DynamiquePayement()}
          </div>
        </>
      )}
      {onSimulate && (
        <SimulateRetenuVente
          setOnSimulate={setOnSimulate}
          simulateData={simulateData}
        />
      )}
    </div>
  );
};
export default withLoader(PayementBillVenteDetails);
